<compartido-ficha [configuracion]="configFicha" class="orden">
  <mat-tab-group
    *ngIf="orden !== undefined"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    dynamicHeight
  >
    <mat-tab tabindex="-1" label="Información">
      <ordenes-datos-orden [idOrden]="orden.id"></ordenes-datos-orden>
    </mat-tab>
    <mat-tab tabindex="-1" label="Fórmulas" *ngIf="orden.formulas.length > 0">
      <ordenes-datos-formula
        *ngFor="let formula of orden.formulas"
        class="formula"
        [idFormula]="formula.id"
      ></ordenes-datos-formula>
    </mat-tab>
    <mat-tab tabindex="-1" label="Items" *ngIf="orden.items.length > 0">
      <ordenes-datos-item
        *ngFor="let item of orden.items"
        class="item"
        [idItem]="item.id"
      ></ordenes-datos-item>
    </mat-tab>
    <ng-container *permisos="{ cliente: [Permiso.VER] }">
      <mat-tab tabindex="-1" label="Cliente">
        <clientes-datos-cliente
          [idCliente]="orden.cliente.id"
          [edicion]="'activable'"
        ></clientes-datos-cliente>
      </mat-tab>
      <mat-tab tabindex="-1" label="Dirección">
        <clientes-datos-direccion
          [idDireccion]="orden.direccion.id"
          [edicion]="'activable'"
        ></clientes-datos-direccion>
      </mat-tab>
      <ng-container *permisos="{ domicilio: [Permiso.VER] }">
        <mat-tab tabindex="-1" label="Domicilio" *ngIf="orden.domicilio">
          <domicilios-datos-domicilio
            [idDomicilio]="orden.domicilio.id"
          ></domicilios-datos-domicilio>
        </mat-tab>
      </ng-container>
    </ng-container>
    <mat-tab tabindex="-1" label="Historial">
      <ordenes-historial-orden [idOrden]="orden.id"></ordenes-historial-orden>
    </mat-tab>
  </mat-tab-group>

  <div class="cargando" *ngIf="cargando()">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <div class="sin-datos" *ngIf="!cargando() && orden === undefined">
    <mat-icon>info</mat-icon>
    <span>No se encontraron datos de la orden.</span>
  </div>
</compartido-ficha>
